/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PedestalTypeEnum = 'STANDARD' | 'EXTENDED' | 'ELECTRICAL';

export const PedestalTypeEnum = {
    STANDARD: 'STANDARD' as PedestalTypeEnum,
    EXTENDED: 'EXTENDED' as PedestalTypeEnum,
    ELECTRICAL: 'ELECTRICAL' as PedestalTypeEnum
};

